import * as yup from 'yup';
import { BlockConfigurationSchema } from '.';
import { BlockGroupSchema } from './block';
import { DashboardInfoSchema, UiSettingsSchema } from './dashboard';
export var DashboardDbValueSchema = yup.array().of(DashboardInfoSchema);
export var BlockGridDbValueSchema = yup.object({
  blocks: yup.array().of(BlockConfigurationSchema),
  groups: yup.array().of(BlockGroupSchema)
});
export var UiSettingsDbValueSchema = UiSettingsSchema;